
import { Button, ButtonType, ButtonVariant } from 'components/core';

interface IconButtonProps {
  icon: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  variant?: ButtonVariant;
  type?: ButtonType;
  className?: string;
}

export const IconButton = ({
  icon,
  label,
  onClick,
  disabled = false,
  loading = false,
  variant,
  type = ButtonType.secondary,
  className,
}: IconButtonProps) => (
  <Button
    type={type}
    variant={variant}
    disabled={disabled || loading}
    onClick={onClick}
    className={className}
  >
    {loading
      ? <span className="spinner-border spinner-border-sm me-2" />
      : <span className="material-icons me-1" style={{ verticalAlign: 'sub' }}>{icon}</span>
    }
    {label}
  </Button>
);